

























  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
  import moment from 'moment';
  import { bindWechatQrcode,isBindOtherWechat,isBindWechat } from '@/apis/myInfo/myInfo';
  import i18n from '@/lang/index';
  import { Dialog, Toast } from 'vant'
  import CommonVue from '@/components/CommonVue/CommonVue';
import { watch } from 'vue';
  //绑定其他微信
  @Component({
    name: 'BindOtherWechatDialog',
    components: {

    },

  })
  export default class BindOtherWechatDialog extends CommonVue {
    private appid:string  = "wx0a889c9e094104e9";
    private qrcode:string = "";
    private show: boolean = false;
    private showCancleButton:boolean = true;
    private bindTimer:any = null;

    @Watch("show")
    onShowChange(newVal:boolean,oldVal:boolean)
    {
      if(newVal == false){
        clearInterval(this.bindTimer);
      }
    }

    getRandomArbitrary(min:number, max:number) {
        return Math.random() * (max - min) + min;
    }

    created(){
      if (this.$store.state.userInfo.usertype === '0') {
        isBindOtherWechat({appid:this.appid}).then((res:any)=>{
          this.$emit('bindState',res.bindState);
          if(res.bindState == 111){//111
              let config = res.config;
              if(config.mustbind > 0){
                if(config.clientRandNum < config.mustbind){
                  this.showCancleButton = false;//关闭取消按钮
                }
              }
              bindWechatQrcode({appid:this.appid}).then((res1:any)=>{
                this.qrcode = res1.url;
                this.show   = true;
              });
              this.bindTimer = setInterval(()=>{
                isBindWechat({appid:this.appid}).then((res2:any)=>{
                  //绑定成功了
                  if(res2.isBind){
                    this.show = false;
                    clearInterval(this.bindTimer);
                  }
                });
              },3000);
          }
        });
      }
    }

    handleClose(){
      this.show = false;
    }
  }
  